define('util/dateTimeConstant',[], function () {
    'use strict';

    /**
     * A listing of date/time moment.js format strings used throughout the
     * client to make it easy to swap/tweak formats and still maintain
     * consistancy.
     */
    var DateTimeConstant = {
        LongDate: "lll",
        ShortDate: "l",
        TimeNoSeconds: "LT",
        SmallDuration: "mm:ss",
        SmallDurationNoLeadingZero: "m:ss",
        LongDurationNoLeadingZero: "h:mm:ss"
    };

    return DateTimeConstant;
});
